import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=0f8ba42e&scoped=true&"
import script from "./ShowVideo.vue?vue&type=script&lang=js&"
export * from "./ShowVideo.vue?vue&type=script&lang=js&"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=0f8ba42e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ba42e",
  null
  
)

export default component.exports